// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Pagination_wrapper__35oH7","item":"Pagination_item__15giO","prev":"Pagination_prev__1ZeOS","next":"Pagination_next__3yCp8","disable":"Pagination_disable__2gM9R"};